import React, {forwardRef, ReactNode} from 'react';
import {CSSTransition} from 'react-transition-group';

interface FadeProps {
  hidden?: boolean;
  children?: ReactNode;
}

export const Fade = forwardRef(<T extends HTMLElement>({ children, hidden }: FadeProps, ref: React.Ref<T>) => (
  <CSSTransition nodeRef={ref} classNames="fade" timeout={450} appear in={!hidden}>
    {children}
  </CSSTransition>
));
